import { createContext } from 'react';

const HighlightContext = createContext();

export default HighlightContext;